<template>
  <a-modal class="business_verify_modal" v-model:open="visible" @cancel="handleCancel" :footer="null">
    <template #title>
      <span v-if="step == 1">Verify Your Business</span>
      <span v-else-if="step == 2 && type == 'email'">Verify with your corporate email</span>
      <span v-else-if="step == 3 && type == 'email'">Please enter the verification code</span>
      <span v-else-if="step == 2 && type == 'license'">Upload business license</span>
    </template>
    <template v-if="step == 1">
      <a-form class="modal_form" ref="formRef" :model="formState">
        <a-form-item
          validateTrigger="blur"
          label=""
          name="name"
          :rules="[{ required: true, message: 'Enter enterprise name' }]"
        >
          <a-auto-complete
            v-model:value="formState.name"
            :options="businessList"
            placeholder="Enter enterprise name"
            @search="handleBusinessSearch"
            @select="handleBusinessSelect"
            autocomplete="off"
            maxlength="40"
            class="business_input"
            :popupClassName="'business_select_dropdown'"
          />
        </a-form-item>
        <div class="verify_title">Select one of the following verification methods</div>
        <div class="verify_section" @click="handleSelectVerify('email')">
          <div class="label">
            <img src="@/assets/images/verify_email.svg" alt="Verify Email" />Verify with your corporate email
          </div>
          <div class="description">Quick and automatic authentication and review</div>
          <img src="@/assets/images/arrow_right_simple.svg" class="verify_icon" alt="" />
        </div>
        <div class="verify_section" @click="handleSelectVerify('license')">
          <div class="label">
            <img src="@/assets/images/verify_license.svg" alt="Verify License" />Upload Business License for
            Verification
          </div>
          <div class="description">
            Through business license certification, enterprises can obtain a special orange logo
          </div>
          <img src="@/assets/images/arrow_right_simple.svg" class="verify_icon" alt="" />
        </div>
      </a-form>
    </template>
    <template v-else-if="step == 2 || step == 3">
      <div v-if="type == 'email'">
        <div v-if="step == 2" class="tip">
          Enter your enterprise email and verification code to complete authentication
        </div>
        <a-form ref="formEmailRef" :model="formState" class="modal_form">
          <a-form-item
            v-if="step == 2"
            validateTrigger="blur"
            label=""
            name="email"
            :rules="[
              { required: true, message: 'Enter your email address' },
              { type: 'email', message: 'Email is not compliant' },
            ]"
          >
            <a-input v-model:value="formState.email" placeholder="Enter your email" />
          </a-form-item>
          <a-form-item
            v-if="step == 3"
            style="margin-top: 30px;"
            validateTrigger="blur"
            label=""
            name="verifyCode"
            :rules="[{ required: true, message: 'Enter code' }]"
          >
            <a-input v-model:value="formState.verifyCode" placeholder="Enter code" />
            <button
              class="send_code_btn"
              @click.prevent="sendSMSCode"
              :style="{ color: sendSMSCodeText !== 'Send code' ? 'rgba(61, 61, 61, 0.5)' : '' }"
            >
              {{ sendSMSCodeText }}
            </button>
          </a-form-item>
          <a-button
            type="primary"
            html-type="button"
            class="submit_btn"
            @click.prevent="handleEmailSubmit"
            :disabled="isSubmitDisabled"
          >
            {{ step == '2' ? 'Next' : 'Done' }}
            <CheckOutlined class="btn_arrow" />
          </a-button>
        </a-form>
      </div>
      <div v-else>
        <div class="go_back" @click="step = 1">Change company name</div>
        <Upload @on-upload="handleOnUploaded" />
        <div class="note">
          <div class="title">Important Notes</div>
          <p>
            <span class="dot"></span>Upload a photo of your business license that matches the full company name provided
          </p>
          <p><span class="dot"></span>Please use the latest business license</p>
          <p><span class="dot"></span>Please ensure that the captured image is clear</p>
        </div>
        <a-button
          type="primary"
          html-type="button"
          class="submit_btn"
          @click.prevent="handleLicenseSubmit"
          :disabled="isSubmitDisabled"
        >
          Confirm and submit
          <CheckOutlined class="btn_arrow" />
        </a-button>
      </div>
    </template>
  </a-modal>
  <a-modal class="business_verify_modal" v-model:open="verifyVisible" @cancel="handleVerifyCancel" :footer="null">
    <div v-if="status == 1" class="status_wrapper">
      <img src="@/assets/images/verify_status_upload.svg" class="status_icon" alt="" />
      <div class="text">Please upload the business license photo first.</div>
      <a-button type="primary" class="submit_btn" @click.prevent="handleVerifyCancel">
        Upload immediately
      </a-button>
    </div>
    <div v-if="status == 2" class="status_wrapper">
      <img src="@/assets/images/verify_status_timeout.svg" class="status_icon" alt="" />
      <div class="text">Today's review quota has been used up. Please try again tomorrow.</div>
      <a-button type="primary" class="submit_btn" @click.prevent="handleVerifyCancel">
        OK, I got it
      </a-button>
    </div>
    <div v-if="status == 3" class="status_wrapper">
      <img src="@/assets/images/verify_status_failed.svg" class="status_icon" alt="" />
      <div class="status_text">Review failed</div>
      <div class="reason_text">
        <div class="title">Reason for rejection：</div>
        <div class="content">{{ verifyReason }}</div>
        <div
          class="change_verfify"
          @click="
            handleVerifyCancel();
            step = 1;
          "
        >
          Change verification method
        </div>
      </div>
      <a-button type="primary" class="submit_btn" @click.prevent="handleVerifyCancel">
        Re-upload
      </a-button>
    </div>
    <div v-if="status == 4" class="status_wrapper">
      <img src="@/assets/images/verify_status_success.svg" class="status_icon" alt="" />
      <div class="status_text">Verification successful</div>
      <div class="company_text">
        <div class="title">{{ formState.name }}</div>
        <div class="content">Congratulations on obtaining the enterprise orange logo/identity</div>
      </div>
    </div>
  </a-modal>
</template>

<script setup>
import { CheckOutlined } from '@ant-design/icons-vue';
import { message } from 'ant-design-vue';
import { ref, defineExpose, reactive, toRaw, defineEmits } from 'vue';

import { verifyEmail, sendVerifyCode, verifyLicense, companySearch } from '@/api/account/businessVerify.js';
import Upload from '@/components/Upload.vue';

const emit = defineEmits(['verify_success']);
const visible = ref(false);
const verifyVisible = ref(false);
const step = ref(1);
const status = ref(2);
const type = ref('');
const formState = reactive({
  name: '',
  email: '',
  verifyCode: '',
  licenseUrl: '',
});

const businessList = ref([]);
const handleBusinessSearch = (name) => {
  companySearch(name).then((res) => {
    if (res.code == 0) {
      businessList.value = res.data
        .map((item) => ({
          value: item.name,
          label: item.name,
        }))
        .slice(0, 10);
    }
  });
};
const handleBusinessSelect = (value) => {
  formState.name = value;
};

const handleCancel = () => {
  visible.value = false;
  step.value = 1;
};
const open = () => {
  visible.value = true;
};
const handleVerifyCancel = () => {
  verifyVisible.value = false;
};
const openVerify = () => {
  verifyVisible.value = true;
};

const formEmailRef = ref(null);
const isSubmitDisabled = ref(false);
const isSMSCodeDisabled = ref(false);
const intervalId = ref(null);
const sendSMSCodeText = ref('Send code');

const startCountdown = (time) => {
  if (isSMSCodeDisabled.value) return;
  if (!time) return;
  isSMSCodeDisabled.value = true;
  var timeLeft = time;
  intervalId.value = setInterval(() => {
    if (timeLeft > 0) {
      timeLeft--;
      sendSMSCodeText.value = timeLeft + ' resend';
    } else {
      clearInterval(intervalId.value);
      timeLeft = 60;
      isSMSCodeDisabled.value = false;
      sendSMSCodeText.value = 'Send code';
    }
  }, 1000);
};

const sendSMSCode = () => {
  formEmailRef.value.validateFields(['email']).then(() => {
    isSMSCodeDisabled.value = true;
    isSubmitDisabled.value = true;
    sendVerifyCode({ email: formState.email }).then((res) => {
      isSMSCodeDisabled.value = false;
      isSubmitDisabled.value = false;
      formEmailRef.value.resetFields(['verifyCode']);
      startCountdown(60);
      if (res.code == 0) {
        message.success(res.msg);
        step.value = 3;
      } else {
        message.error(res.msg);
      }
    });
  });
};

const handleEmailSubmit = () => {
  if (step.value == 2) {
    sendSMSCode();
  } else if (step.value == 3) {
    formEmailRef.value.validate().then(() => {
      isSubmitDisabled.value = true;
      verifyEmail(toRaw(formState)).then((res) => {
        isSubmitDisabled.value = false;
        if (res.code == 0) {
          message.success(res.msg);
          handleCancel();
          emit('verifySuccess', res.data);
        } else {
          message.error(res.msg);
        }
      });
    });
  }
};

const formRef = ref(null);
const handleSelectVerify = (selectedType) => {
  formRef.value.validate().then(() => {
    type.value = selectedType;
    step.value = 2;
  });
};

const handleOnUploaded = (fileUrl) => {
  formState.licenseUrl = fileUrl;
};

const verifyReason = ref('');
const handleLicenseSubmit = () => {
  if (formState.licenseUrl === '') {
    openVerify();
    status.value = 1;
    return;
  }
  isSubmitDisabled.value = true;
  verifyLicense(toRaw(formState)).then((res) => {
    isSubmitDisabled.value = false;
    if (res.code == 0) {
      openVerify();
      status.value = 4;
    } else if (res.code == 30001) {
      openVerify();
      status.value = 3;
      verifyReason.value = res.msg;
    }
  });
};

defineExpose({
  open,
});
</script>

<style lang="less">
.business_verify_modal {
  color: #05644f;
  font-size: 16px;
  .ant-modal-content {
    border-radius: 20px;
    padding: 32px;
  }
  .ant-modal-title {
    color: #05644f;
    font-size: 20px;
    font-weight: bold;
    line-height: normal;
  }
  .ant-modal-close-icon {
    color: #05644f;
  }
  .modal_form {
    margin-top: 20px;
    .business_input.ant-select {
      &.ant-select-status-error .ant-select-selector {
        border-color: #ff7875 !important;
      }
      .ant-select-selector {
        border: 1px solid rgba(5, 100, 79, 0.5) !important;
        box-shadow: 0px 4px 10px 0px rgba(0, 0, 0, 0.03) !important;
        border-radius: 16px;
        height: 46px;
        .ant-select-selection-search-input {
          font-size: 14px;
          padding: 10px 13px;
          height: auto;
          color: #05644f;
        }
        .ant-select-selection-placeholder {
          color: rgba(5, 100, 79, 0.33);
          font-size: 14px;
          line-height: 42px;
          padding: 0 13px;
        }
      }
    }
    .ant-input {
      border: 1px solid rgba(5, 100, 79, 0.5);
      box-shadow: 0px 4px 10px 0px rgba(0, 0, 0, 0.03);
      border-radius: 16px;
      padding: 10px;
      font-size: 14px;
      color: #05644f;
    }
    .ant-input::placeholder {
      color: rgba(5, 100, 79, 0.33);
    }
    .send_code_btn {
      position: absolute;
      right: 24px;
      top: 12px;
      color: #05644f;
      background: transparent;
      border: none;
      cursor: pointer;
      font-weight: 500;
      min-width: 30px;
    }
    .ant-form-item-explain-error {
      margin-bottom: 24px;
    }
  }
  .submit_btn {
    background: #05644f;
    border-radius: 100px;
    color: #fff;
    font-size: 18px;
    font-weight: bold;
    line-height: normal;
    display: block;
    width: 100%;
    padding: 10px 20px;
    height: auto;
    margin-top: 20px;
    &:hover {
      background: #05644f;
      color: #fff;
    }
    .btn_arrow {
      margin-left: 10px;
      font-size: 18px;
    }
  }
  .verify_title {
    font-size: 12px;
    font-weight: bold;
    color: #333;
    margin-bottom: 10px;
  }
  .verify_section {
    margin-bottom: 20px;
    padding: 20px;
    color: #05644f;
    border: 1px solid rgba(5, 100, 79, 0.5);
    border-radius: 16px;
    position: relative;
    cursor: pointer;
    .label {
      font-size: 14px;
      font-weight: bold;
      margin-bottom: 10px;
      img {
        width: 24px;
        height: 24px;
        margin-right: 10px;
        vertical-align: text-bottom;
      }
    }
    .description {
      font-size: 12px;
      width: auto;
      padding-right: 30px;
      box-sizing: border-box;
    }
    .verify_icon {
      width: 8px;
      height: 14px;
      position: absolute;
      right: 20px;
      top: calc(50% - 12px);
    }
    &:hover {
      background: rgba(5, 100, 79, 0.3);
    }
  }
  .go_back {
    font-size: 14px;
    font-weight: 500;
    color: #0256ff;
    cursor: pointer;
  }
  .upload_wrapper {
    margin: 30px auto;
  }
  .note {
    color: #3d3d3d;
    .title {
      font-size: 14px;
      font-weight: bold;
      margin-bottom: 8px;
    }
    p {
      font-size: 12px;
      font-weight: 300;
      margin-bottom: 2px;
      .dot {
        width: 6px;
        height: 6px;
        border-radius: 50%;
        background: #05644f;
        margin-right: 8px;
        display: inline-block;
      }
    }
  }
  .status_wrapper {
    padding-top: 45px;
    text-align: center;
    .status_icon {
      width: 80px;
      height: 80px;
    }
    .text {
      color: #3d3d3d;
      font-size: 16px;
      margin: 30px auto;
    }
    .status_text {
      font-size: 20px;
      font-weight: bold;
      margin-top: 16px;
    }
    .reason_text {
      text-align: left;
      font-size: 14px;
      font-weight: 500;
      margin-top: 8px;
      div {
        margin-bottom: 8px;
      }
      .title {
        color: #3d3d3d;
      }
      .content {
        color: #f78335;
      }
      .change_verfify {
        color: #0256ff;
        cursor: pointer;
      }
    }
    .company_text {
      margin: 24px auto;
      font-size: 16px;
      color: #3d3d3d;
      .title {
        font-size: 20px;
      }
    }
  }
}
.business_select_dropdown {
  background: #fff;
  min-width: 200px !important;
  padding: 10px;
  .ant-select-item {
    color: #05644f;
    background: #fff;
    &:hover,
    &.ant-select-item-option-active,
    &.ant-select-item-option-selected {
      background: rgba(5, 100, 79, 0.1);
      color: #05644f;
    }
  }
}
</style>
